/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import { useState } from 'react';
import { Button, Classes, ControlGroup, InputGroup } from '@blueprintjs/core';
import { Dialog } from 'components/dialogs';

export const AddDescriptionDialog = ({ initialDescription, closeDialog, handleSubmit }) => {
	const [description, setDescription] = useState(initialDescription || '');

	const updateDescription = (e) => {
		e.preventDefault();
		setDescription(e.target.value);
	}
	return (
		<Dialog 
			style={styles.Dialog} 
			title={"Add Description"} 
			body = {
				<div className={Classes.DIALOG_BODY}>
					<ControlGroup>
						<InputGroup
							onChange={updateDescription}
							placeholder={`Description...`}
							value={description}
							fill
						/>
					</ControlGroup>
				</div> 
			}
			onClose={closeDialog} 
			footer = {
				<div className={Classes.DIALOG_FOOTER} >
					<Button minimal={true} css={css `.bp3-button-text {color: #5c7080;}`} onClick={closeDialog}>Cancel</Button> 
					<Button outlined={true} onClick={() => handleSubmit(description)} intent="primary">Save</Button>
				</div>
			}
		/>
	)
}

const styles = { 
	Dialog: css`
	.bp3-button{ 
		margin-left: 5px; 
	}

	.bp3-dialog-footer{ 
		text-align: right; 
	}
	background: white;
`,	
}